import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import NoMatch from "./404";
import Unauthorized from "./403";
import PrivateRoute from "./privateRoute";
import Loading from "./_loading";
import LayoutDecider from "./layoutDecider";

const Login = React.lazy(() => import("../login"));
const Register = React.lazy(() => import("../register"));
const ForgotPassword = React.lazy(() => import("../forgotPassword"));
const Profile = React.lazy(() => import("../profile"));
const ChangePassword = React.lazy(() => import("../changePassword"));
const PasswordReset = React.lazy(() => import("../passwordReset"));
const Dashboard = React.lazy(() => import("../admin/dashboard"));
//const UserList = React.lazy(() => import("../admin/userlist"));
//const User = React.lazy(() => import("../admin/user"));
const SeriLogs = React.lazy(() => import("../admin/seriLog"));
const EmailLog = React.lazy(() => import("../admin/emailLog"));

const WebUsers = React.lazy(() => import("../admin/webuser/webuser"));
const WebUsersDetail = React.lazy(
  () => import("../admin/webuser/webuser-detail"),
);

const Bed = React.lazy(() => import("../admin/bed/bed"));
const BedDetail = React.lazy(() => import("../admin/bed/bed-detail"));

const Room = React.lazy(() => import("../admin/room/room"));
const RoomDetail = React.lazy(() => import("../admin/room/room-detail"));

const Booking = React.lazy(() => import("../admin/booking/booking"));
const CheckOut = React.lazy(() => import("../admin/booking/checkout"));
const BookingDetail = React.lazy(
  () => import("../admin/booking/booking-detail"),
);
const BookingDetailPreview = React.lazy(
  () => import("../admin/booking/booking-detail-preview"),
);
const Invoice = React.lazy(() => import("../admin/booking/invoice"));
const AdvanceReceipt = React.lazy(
  () => import("../admin/booking/advance-receipt"),
);

const Payment = React.lazy(() => import("../admin/payment/payment"));
const BookingReport = React.lazy(
  () => import("../admin/report/booking-report"),
);
const BookingDetailUpdate = React.lazy(
  () => import("../admin/booking/booking-detail-update"),
);

const Product = React.lazy(() => import("../admin/product/product"));
const ProductDetail = React.lazy(
  () => import("../admin/product/product-detail"),
);
const ProductStockDetail = React.lazy(
  () => import("../admin/product/product-stock-detail"),
);

const DailyReport = React.lazy(() => import("../admin/report/daily-report"));

const Router = function () {
  return (
    <Routes>
      <Route path="/" element={<LayoutDecider />}>
        <Route
          index
          path="/"
          element={
            <Suspense fallback={<Loading />}>
              <Login />
            </Suspense>
          }
        />
        <Route
          path="/login"
          element={
            <Suspense fallback={<Loading />}>
              {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLERECAPCHA_KEY} scriptProps={{ defer: true, async: true }}> */}
              <Login />
              {/* </GoogleReCaptchaProvider> */}
            </Suspense>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <Suspense fallback={<Loading />}>
              <ForgotPassword />
            </Suspense>
          }
        />
        <Route
          path="/password-reset"
          element={
            <Suspense fallback={<Loading />}>
              {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLERECAPCHA_KEY} scriptProps={{ defer: true, async: true }}> */}
              <PasswordReset />
              {/* </GoogleReCaptchaProvider> */}
            </Suspense>
          }
        />
        <Route
          path="/register"
          element={
            <Suspense fallback={<Loading />}>
              {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLERECAPCHA_KEY} scriptProps={{ defer: true, async: true }}> */}
              <Register />
              {/* </GoogleReCaptchaProvider> */}
            </Suspense>
          }
        />
        <Route
          path="/profile"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          path="/change-password"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute>
                <ChangePassword />
              </PrivateRoute>
            </Suspense>
          }
        />

        <Route
          index
          path="/dashboard"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <Dashboard />
              </PrivateRoute>
            </Suspense>
          }
        />

        {/* Bed */}
        <Route
          index
          path="/bed"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <Bed />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/bed/detail/:type/:id?"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <BedDetail />
              </PrivateRoute>
            </Suspense>
          }
        />
        {/* Bed */}

        {/* Room */}
        <Route
          index
          path="/room"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <Room />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/room/detail/:type/:id?"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <RoomDetail />
              </PrivateRoute>
            </Suspense>
          }
        />
        {/* Room */}

        {/* Product */}
        <Route
          index
          path="/product"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <Product />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/product/detail/:type/:id?"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <ProductDetail />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/product/stock/detail/:type/:id?"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <ProductStockDetail />
              </PrivateRoute>
            </Suspense>
          }
        />
        {/* Product */}

        {/* Payment */}
        <Route
          index
          path="/payment-history"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <Payment />
              </PrivateRoute>
            </Suspense>
          }
        />
        {/* Payment */}

        <Route
          index
          path="/booking-report"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <BookingReport />
              </PrivateRoute>
            </Suspense>
          }
        />

        <Route
          index
          path="/report/daily-report"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <DailyReport />
              </PrivateRoute>
            </Suspense>
          }
        />

        {/* Booking */}
        <Route
          index
          path="/booking/detail/update/:id"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <BookingDetailUpdate />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/booking"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <Booking />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/checkout"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <CheckOut />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/room/booking/detail/:type/:id?"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <BookingDetail />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/room/booking/detail/:roomtype/:type/:id?"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <BookingDetail />
              </PrivateRoute>
            </Suspense>
          }
        />

        <Route
          index
          path="/room/booking/detail/preview/:id?"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <BookingDetailPreview />
              </PrivateRoute>
            </Suspense>
          }
        />

        <Route
          path="/room/booking/detail/invoice/:id"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <Invoice />
              </PrivateRoute>
            </Suspense>
          }
        />

        <Route
          path="/room/booking/detail/advance-receipt/:id"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <AdvanceReceipt />
              </PrivateRoute>
            </Suspense>
          }
        />

        {/* Booking */}

        {/* Web Users */}
        <Route
          index
          path="/:userType/user/list"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <WebUsers />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/:userType/detail/:type/:id?"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <WebUsersDetail />
              </PrivateRoute>
            </Suspense>
          }
        />
        {/* Web Users */}

        <Route
          index
          path="/admin/serilog/list"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <SeriLogs />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          index
          path="/admin/emaillog/list"
          element={
            <Suspense fallback={<Loading />}>
              <PrivateRoute role="ADMIN">
                <EmailLog />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route path="*" element={<NoMatch />} />
      </Route>
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
};

export default Router;
